import React, { useState } from 'react'
import './profilePictureModal.css'
import { translations } from '../../../utils/Translation/staticTranslation'

const ProfilePictureModal = ({
  isOpen,
  onClose,
  profileImage,
  onRemove,
  onChangeClick,
  lang,
  common_btn,
  userInitials,
  isLoading = false,
}) => {
  const [mode, setMode] = useState('edit')

  if (!isOpen) return null

  const handleRemoveClick = () => {
    setMode('confirmRemove')
  }

  const handleCancelRemove = () => {
    setMode('edit')
  }

  const handleConfirmRemove = () => {
    onRemove()
  }

  const settingPage = translations[lang]?.settingPage
  const btn = translations[lang]?.common_btn

  const renderEditMode = () => (
    <>
      <div className='profile-image-container-modal'>
        {profileImage ? (
          <img
            src={profileImage}
            alt='Profile'
            className='profile-image-modal'
          />
        ) : (
          <div className='default-initials-container'>
            <p className='default-initials'>{userInitials}</p>
          </div>
        )}
      </div>
      <h2 className='profile-modal-title'>{settingPage?.update_profile_modal?.update_profile}</h2>
      <p className='profile-modal-subtitle'>
        {settingPage?.update_profile_modal?.resolution}
      </p>

      <div className='profile-modal-actions'>
        <button
          className='remove-btn'
          onClick={handleRemoveClick}
          disabled={isLoading}
        >
          <img src='/icons/delete-icon-dark.svg' alt='delete-icon' />
          {settingPage?.remove || 'Remove'}
        </button>

        <button
          className='change-btn'
          onClick={onChangeClick}
          disabled={isLoading}
        >
          <img src='/icons/editPicIcon.svg' alt='editPicIcon' width={20} />
          {common_btn?.change || 'Change'}
        </button>
      </div>
    </>
  )

  const renderConfirmRemoveMode = () => (
    <>
      <div className='profile-transition-container'>
        <div className='profile-circle current'>
          {profileImage ? (
            <img
              src={profileImage}
              alt='Current Profile'
              className='profile-image-circle'
            />
          ) : (
            <div className='empty-profile-circle'>
              <span className='profile-initials'>{userInitials}</span>
            </div>
          )}
        </div>

        <div className='transition-arrow'>
          <img src='/icons/chnage-arrow-sign.svg' alt='Arrow' />
        </div>

        <div className='profile-circle default'>
          <div className='empty-profile-circle'>
            <span className='profile-initials'>{userInitials}</span>
          </div>
        </div>
      </div>

      <h2 className='profile-modal-title'>{settingPage?.update_profile_modal?.remove_profile}</h2>
      <p className='profile-modal-subtitle'>
       {settingPage?.update_profile_modal?.remove_profile_description}
      </p>

      <div className='profile-modal-actions'>
        <button
          className='cancel-btn-modal'
          onClick={handleCancelRemove}
          disabled={isLoading}
        >
          {btn?.cancel_btn}
        </button>

        <button
          className='confirm-remove-btn'
          onClick={handleConfirmRemove}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className='loading-spinner'></span>
          ) : (
            <img src='/icons/delete-icon.svg' alt='delete-icon' width={13} />
          )}
          {isLoading ? settingPage?.update_profile_modal?.Processing : settingPage?.remove}
        </button>
      </div>
    </>
  )

  return (
    <div className='profile-modal-overlay'>
      <div className='profile-modal-content'>
        {isLoading && (
          <div className='loading-overlay'>
            <div className='loading-spinner'></div>
          </div>
        )}

        <div className='profile-modal-header'>
          <button
            className='close-button'
            onClick={mode === 'edit' ? onClose : handleCancelRemove}
            disabled={isLoading}
          >
            <img src='/icons/close-icon.svg' alt='Close' />
          </button>
        </div>

        {mode === 'edit' ? renderEditMode() : renderConfirmRemoveMode()}
      </div>
    </div>
  )
}

export default ProfilePictureModal
